import { QuestionnaireAttemptOverallResultEnum } from '@/models/gen/graphql';
import { Schema } from '@/utils';

export namespace CompleteEvaluationWizardTypes {
  export type FormValues = {
    fieldNotes?: string;
    overallResult?: QuestionnaireAttemptOverallResultEnum | '';
  };

  export enum Step {
    FIELD_NOTES = 1,
    COMPLETION = 2,
  }

  export const OverallResultLabel: Record<QuestionnaireAttemptOverallResultEnum, string> = {
    [QuestionnaireAttemptOverallResultEnum.Pass]: 'Pass',
    [QuestionnaireAttemptOverallResultEnum.MoreTrainingRequired]: 'More Training Required',
    [QuestionnaireAttemptOverallResultEnum.Fail]: 'Fail',
  };

  export const OPTIONS: { value: QuestionnaireAttemptOverallResultEnum; color: string; description: string }[] = [
    {
      value: QuestionnaireAttemptOverallResultEnum.Pass,
      color: '#0F9D58',
      description: 'Trainee demonstrated the required skills, knowledge, and competencies to operate independently.',
    },
    {
      value: QuestionnaireAttemptOverallResultEnum.MoreTrainingRequired,
      color: '#FF9E16',
      description: 'Trainers must document specific skills, policies, or areas needing improvement.',
    },
    {
      value: QuestionnaireAttemptOverallResultEnum.Fail,
      color: '#C00403',
      description:
        'Trainee did not demonstrate the minimum competencies required for independent operation. Termination recommended. Trainer must document specific deficiencies and examples observed.',
    },
  ];

  export const Validator = () =>
    Schema((z) =>
      z
        .object({
          fieldNotes: z.preprocess(
            (str: string) => (str?.trim() ? str : undefined),
            z.string().min(3, { message: 'Must be at least 3 characters' }).optional()
          ),
          overallResult: z.nativeEnum(QuestionnaireAttemptOverallResultEnum, { message: 'Required' }),
        })
        .superRefine((data, ctx) => {
          if (data.overallResult === QuestionnaireAttemptOverallResultEnum.Pass) return;
          const fieldNotes = data.fieldNotes?.trim() ?? '';
          if (fieldNotes.length === 0) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'Required',
              path: ['fieldNotes'],
            });
          }
        })
    );
}
